/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
import { AddOrUpdateDefaultMessageCommandDtoToJSON, AddOrUpdateDefaultMessageResultFromJSON, AddUserCommentCommandDtoToJSON, BuyCreditsCommandDtoToJSON, ChatMessageDtoFromJSON, CloseJobCommandDtoToJSON, CloseMatchCommandDtoToJSON, ConvertLeadCompanyToCustomerCommandDtoToJSON, CreateCompanyForEmployerCommandDtoToJSON, CreateCompanyHireReportCommandDtoToJSON, CreateEmployerCommandDtoToJSON, CreateEmployerInviteCommandDtoToJSON, CreateEmployerResponseFromJSON, CreateFirebaseAccountForLeadCommandDtoToJSON, CreateFirebaseAccountForLeadResultFromJSON, CreateJobCommandDtoToJSON, CreateTeammateInviteCommandDtoToJSON, DeleteDefaultMessageResultFromJSON, DeleteEmployerCommandDtoToJSON, EditUserCommentCommandDtoToJSON, FindBestCandidateResultFromJSON, GetAtsIntegrationConnectionResultHomerunConnectionConfigFromJSON, GetAtsIntegrationConnectionResultRecruiteeConnectionConfigFromJSON, GetCompanyFromPortalResultFromJSON, GetCompanyHireReportInfoResultFromJSON, GetCompanyMatchingConfigurationResultFromJSON, GetCompanyPlanResultFromJSON, GetCompanyStatisticsResultFromJSON, GetConferenceChatWithMessagesForEmployerResultFromJSON, GetConferenceInfoResultFromJSON, GetEmployerAccessResultFromJSON, GetEmployerOnboardingStatusResultFromJSON, GetEmployerProfileResultFromJSON, GetInvoiceFileUrlResultFromJSON, GetJobApplicationResultFromJSON, GetJobNotificationSettingsResultFromJSON, GetJobResultFromJSON, GetLeadEmployerResultFromJSON, GetMatchChatWithMessagesResultFromJSON, GetMatchedUserResultFromJSON, GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecretsToJSON, GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecretsToJSON, GetSubscriptionResultFromJSON, GetUserCommentsResultFromJSON, ImageDtoFromJSON, IntegrationConnectionDtoFromJSON, ListAllSkillsResultFromJSON, ListAllWaitingJobApplicationsResultFromJSON, ListAtsJobsResultFromJSON, ListCompanySubscriptionsResultFromJSON, ListConferenceChatsResultFromJSON, ListCreditTransactionsResultFromJSON, ListEducationLevelsWithTrackCategoryResultFromJSON, ListIntegrationsResultFromJSON, ListInvoicesForCompanyResultFromJSON, ListJobApplicationRejectionReasonsResultFromJSON, ListJobApplicationsForJobResultFromJSON, ListJobsInPortalResultFromJSON, ListManagedCompaniesResultFromJSON, ListMatchesForJobResultFromJSON, ListMatchesResultFromJSON, ListOtherEmployersForCompanyResultFromJSON, ListPaymentOptionsResultFromJSON, ListReferralInvitesResultFromJSON, ListUnhandledJobsResultFromJSON, ListUnhandledMatchesResultFromJSON, ListUnreadConferenceChatsResultFromJSON, MapJobWithAtsJobCommandDtoToJSON, MarkMatchCommandDtoToJSON, ReactToCandidateCommandDtoToJSON, RejectJobApplicationCommandDtoToJSON, RejectJobApplicationResultFromJSON, SendCompleteProfileRequestCommandDtoToJSON, SendMessageCommandDtoToJSON, SendPollCommandDtoToJSON, SendPollResultFromJSON, SendRequestToAccountManagerCommandDtoToJSON, SetCompanyMatchingConfigurationCommandDtoToJSON, StartMatchCommandDtoToJSON, StartMatchResultFromJSON, UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfigToJSON, UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfigToJSON, UpdateCompanyFromPortalCommandDtoToJSON, UpdateEmployerProfileCommandDtoToJSON, UpdateJobCommandDtoToJSON, UpdateJobNotificationSettingsCommandDtoToJSON, UpdateJobPublishedCommandDtoToJSON, } from '../models/index.js';
/**
 *
 */
export class EmployerApi extends runtime.BaseAPI {
    /**
     */
    async addOrUpdateDefaultMessageRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/company/default-messages`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrUpdateDefaultMessageCommandDtoToJSON(requestParameters['addOrUpdateDefaultMessageCommandDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => AddOrUpdateDefaultMessageResultFromJSON(jsonValue));
    }
    /**
     */
    async addOrUpdateDefaultMessage(addOrUpdateDefaultMessageCommandDto, initOverrides) {
        const response = await this.addOrUpdateDefaultMessageRaw({ addOrUpdateDefaultMessageCommandDto: addOrUpdateDefaultMessageCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     * Add a new internal comment about a user (candidate).
     */
    async addUserCommentRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/v1/employer/user/comments`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddUserCommentCommandDtoToJSON(requestParameters['addUserCommentCommandDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Add a new internal comment about a user (candidate).
     */
    async addUserComment(addUserCommentCommandDto, initOverrides) {
        await this.addUserCommentRaw({ addUserCommentCommandDto: addUserCommentCommandDto }, initOverrides);
    }
    /**
     */
    async buyCreditsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/invoice/credits`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BuyCreditsCommandDtoToJSON(requestParameters['buyCreditsCommandDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async buyCredits(buyCreditsCommandDto, initOverrides) {
        await this.buyCreditsRaw({ buyCreditsCommandDto: buyCreditsCommandDto }, initOverrides);
    }
    /**
     * Close a Job, this will make it unavailable for new matches
     */
    async closeJobRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job/close`;
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CloseJobCommandDtoToJSON(requestParameters['closeJobCommandDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Close a Job, this will make it unavailable for new matches
     */
    async closeJob(closeJobCommandDto, initOverrides) {
        await this.closeJobRaw({ closeJobCommandDto: closeJobCommandDto }, initOverrides);
    }
    /**
     */
    async closeMatchRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/match/close`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CloseMatchCommandDtoToJSON(requestParameters['closeMatchCommandDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async closeMatch(closeMatchCommandDto, initOverrides) {
        await this.closeMatchRaw({ closeMatchCommandDto: closeMatchCommandDto }, initOverrides);
    }
    /**
     */
    async connectHomerunIntegrationRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/homerun-connection`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecretsToJSON(requestParameters['getOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IntegrationConnectionDtoFromJSON(jsonValue));
    }
    /**
     */
    async connectHomerunIntegration(getOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets, initOverrides) {
        const response = await this.connectHomerunIntegrationRaw({ getOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets: getOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets }, initOverrides);
        return await response.value();
    }
    /**
     */
    async connectRecruiteeIntegrationRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/recruitee-connection`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecretsToJSON(requestParameters['getOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IntegrationConnectionDtoFromJSON(jsonValue));
    }
    /**
     */
    async connectRecruiteeIntegration(getOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets, initOverrides) {
        const response = await this.connectRecruiteeIntegrationRaw({ getOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets: getOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets }, initOverrides);
        return await response.value();
    }
    /**
     */
    async convertLeadCompanyToRegularRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/lead/company`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConvertLeadCompanyToCustomerCommandDtoToJSON(requestParameters['convertLeadCompanyToCustomerCommandDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async convertLeadCompanyToRegular(convertLeadCompanyToCustomerCommandDto, initOverrides) {
        await this.convertLeadCompanyToRegularRaw({ convertLeadCompanyToCustomerCommandDto: convertLeadCompanyToCustomerCommandDto }, initOverrides);
    }
    /**
     */
    async createCompanyForEmployerRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/employer-onboarding/create-company`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCompanyForEmployerCommandDtoToJSON(requestParameters['createCompanyForEmployerCommandDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async createCompanyForEmployer(createCompanyForEmployerCommandDto, initOverrides) {
        await this.createCompanyForEmployerRaw({ createCompanyForEmployerCommandDto: createCompanyForEmployerCommandDto }, initOverrides);
    }
    /**
     */
    async createCompanyHireReportRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/hire-report`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCompanyHireReportCommandDtoToJSON(requestParameters['createCompanyHireReportCommandDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createCompanyHireReport(createCompanyHireReportCommandDto, initOverrides) {
        const response = await this.createCompanyHireReportRaw({ createCompanyHireReportCommandDto: createCompanyHireReportCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     */
    async createEmployerRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/v2/onboarding/register`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEmployerCommandDtoToJSON(requestParameters['createEmployerCommandDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEmployerResponseFromJSON(jsonValue));
    }
    /**
     */
    async createEmployer(createEmployerCommandDto, initOverrides) {
        const response = await this.createEmployerRaw({ createEmployerCommandDto: createEmployerCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     */
    async createEmployerInviteRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/admin/employer/create-employer-invite/employer`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEmployerInviteCommandDtoToJSON(requestParameters['createEmployerInviteCommandDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async createEmployerInvite(createEmployerInviteCommandDto, initOverrides) {
        await this.createEmployerInviteRaw({ createEmployerInviteCommandDto: createEmployerInviteCommandDto }, initOverrides);
    }
    /**
     */
    async createFirebaseAccountForLeadRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/lead/account`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFirebaseAccountForLeadCommandDtoToJSON(requestParameters['createFirebaseAccountForLeadCommandDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFirebaseAccountForLeadResultFromJSON(jsonValue));
    }
    /**
     */
    async createFirebaseAccountForLead(createFirebaseAccountForLeadCommandDto, initOverrides) {
        const response = await this.createFirebaseAccountForLeadRaw({ createFirebaseAccountForLeadCommandDto: createFirebaseAccountForLeadCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     * Create a Job post
     */
    async createJobRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateJobCommandDtoToJSON(requestParameters['createJobCommandDto']),
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Create a Job post
     */
    async createJob(createJobCommandDto, initOverrides) {
        const response = await this.createJobRaw({ createJobCommandDto: createJobCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     */
    async createTeammateInviteRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/admin/employer/create-teammate-invite/teammate`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTeammateInviteCommandDtoToJSON(requestParameters['createTeammateInviteCommandDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async createTeammateInvite(createTeammateInviteCommandDto, initOverrides) {
        await this.createTeammateInviteRaw({ createTeammateInviteCommandDto: createTeammateInviteCommandDto }, initOverrides);
    }
    /**
     */
    async deleteDefaultMessageRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteDefaultMessage().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/company/default-messages/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteDefaultMessageResultFromJSON(jsonValue));
    }
    /**
     */
    async deleteDefaultMessage(id, initOverrides) {
        const response = await this.deleteDefaultMessageRaw({ id: id }, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteIntegrationConnectionRaw(requestParameters, initOverrides) {
        if (requestParameters['connectionId'] == null) {
            throw new runtime.RequiredError('connectionId', 'Required parameter "connectionId" was null or undefined when calling deleteIntegrationConnection().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/integration-connection/{connectionId}`;
        urlPath = urlPath.replace(`{${"connectionId"}}`, encodeURIComponent(String(requestParameters['connectionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteIntegrationConnection(connectionId, initOverrides) {
        const response = await this.deleteIntegrationConnectionRaw({ connectionId: connectionId }, initOverrides);
        return await response.value();
    }
    /**
     * Delete a Company. This will close all related matches, jobs and other data.
     */
    async deleteMyCompanyRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/company`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Delete a Company. This will close all related matches, jobs and other data.
     */
    async deleteMyCompany(initOverrides) {
        const response = await this.deleteMyCompanyRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteTeammateRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/admin/employer/delete-teammate/teammate`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteEmployerCommandDtoToJSON(requestParameters['deleteEmployerCommandDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteTeammate(deleteEmployerCommandDto, initOverrides) {
        await this.deleteTeammateRaw({ deleteEmployerCommandDto: deleteEmployerCommandDto }, initOverrides);
    }
    /**
     * Soft-delete a comment (only by the author).
     */
    async deleteUserCommentRaw(requestParameters, initOverrides) {
        if (requestParameters['commentId'] == null) {
            throw new runtime.RequiredError('commentId', 'Required parameter "commentId" was null or undefined when calling deleteUserComment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/v1/employer/user/comments/{commentId}`;
        urlPath = urlPath.replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters['commentId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Soft-delete a comment (only by the author).
     */
    async deleteUserComment(commentId, initOverrides) {
        await this.deleteUserCommentRaw({ commentId: commentId }, initOverrides);
    }
    /**
     * Edit an existing comment (only by the author).
     */
    async editUserCommentRaw(requestParameters, initOverrides) {
        if (requestParameters['commentId'] == null) {
            throw new runtime.RequiredError('commentId', 'Required parameter "commentId" was null or undefined when calling editUserComment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/v1/employer/user/comments/{commentId}`;
        urlPath = urlPath.replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters['commentId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EditUserCommentCommandDtoToJSON(requestParameters['editUserCommentCommandDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Edit an existing comment (only by the author).
     */
    async editUserComment(commentId, editUserCommentCommandDto, initOverrides) {
        await this.editUserCommentRaw({ commentId: commentId, editUserCommentCommandDto: editUserCommentCommandDto }, initOverrides);
    }
    /**
     * Find the best candidate for the specified job
     */
    async findBestCandidateRaw(requestParameters, initOverrides) {
        if (requestParameters['jobId'] == null) {
            throw new runtime.RequiredError('jobId', 'Required parameter "jobId" was null or undefined when calling findBestCandidate().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job/{jobId}/find-best-candidate`;
        urlPath = urlPath.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters['jobId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FindBestCandidateResultFromJSON(jsonValue));
    }
    /**
     * Find the best candidate for the specified job
     */
    async findBestCandidate(jobId, initOverrides) {
        const response = await this.findBestCandidateRaw({ jobId: jobId }, initOverrides);
        return await response.value();
    }
    /**
     */
    async getCompanyHireReportInfoRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/hire-report`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompanyHireReportInfoResultFromJSON(jsonValue));
    }
    /**
     */
    async getCompanyHireReportInfo(initOverrides) {
        const response = await this.getCompanyHireReportInfoRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getConferenceChatWithMessagesForEmployerRaw(requestParameters, initOverrides) {
        if (requestParameters['chatId'] == null) {
            throw new runtime.RequiredError('chatId', 'Required parameter "chatId" was null or undefined when calling getConferenceChatWithMessagesForEmployer().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/conference/chat/{chatId}`;
        urlPath = urlPath.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters['chatId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetConferenceChatWithMessagesForEmployerResultFromJSON(jsonValue));
    }
    /**
     */
    async getConferenceChatWithMessagesForEmployer(chatId, initOverrides) {
        const response = await this.getConferenceChatWithMessagesForEmployerRaw({ chatId: chatId }, initOverrides);
        return await response.value();
    }
    /**
     */
    async getConferenceInfoRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/conference`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetConferenceInfoResultFromJSON(jsonValue));
    }
    /**
     */
    async getConferenceInfo(initOverrides) {
        const response = await this.getConferenceInfoRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getEmployerAccessRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/profile/access`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetEmployerAccessResultFromJSON(jsonValue));
    }
    /**
     */
    async getEmployerAccess(initOverrides) {
        const response = await this.getEmployerAccessRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getEmployerOnboardingStatusRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['inviteId'] != null) {
            queryParameters['inviteId'] = requestParameters['inviteId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/v2/onboarding`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetEmployerOnboardingStatusResultFromJSON(jsonValue));
    }
    /**
     */
    async getEmployerOnboardingStatus(inviteId, initOverrides) {
        const response = await this.getEmployerOnboardingStatusRaw({ inviteId: inviteId }, initOverrides);
        return await response.value();
    }
    /**
     */
    async getHomerunConnectionRaw(requestParameters, initOverrides) {
        if (requestParameters['connectionId'] == null) {
            throw new runtime.RequiredError('connectionId', 'Required parameter "connectionId" was null or undefined when calling getHomerunConnection().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/homerun-connection/{connectionId}`;
        urlPath = urlPath.replace(`{${"connectionId"}}`, encodeURIComponent(String(requestParameters['connectionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetAtsIntegrationConnectionResultHomerunConnectionConfigFromJSON(jsonValue));
    }
    /**
     */
    async getHomerunConnection(connectionId, initOverrides) {
        const response = await this.getHomerunConnectionRaw({ connectionId: connectionId }, initOverrides);
        return await response.value();
    }
    /**
     */
    async getInvoiceFileUrlRaw(requestParameters, initOverrides) {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError('fileId', 'Required parameter "fileId" was null or undefined when calling getInvoiceFileUrl().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/invoice/{fileId}`;
        urlPath = urlPath.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters['fileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvoiceFileUrlResultFromJSON(jsonValue));
    }
    /**
     */
    async getInvoiceFileUrl(fileId, initOverrides) {
        const response = await this.getInvoiceFileUrlRaw({ fileId: fileId }, initOverrides);
        return await response.value();
    }
    /**
     */
    async getJobRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getJob().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetJobResultFromJSON(jsonValue));
    }
    /**
     */
    async getJob(id, initOverrides) {
        const response = await this.getJobRaw({ id: id }, initOverrides);
        return await response.value();
    }
    /**
     * Get a specific job application
     */
    async getJobApplicationRaw(requestParameters, initOverrides) {
        if (requestParameters['jobApplicationId'] == null) {
            throw new runtime.RequiredError('jobApplicationId', 'Required parameter "jobApplicationId" was null or undefined when calling getJobApplication().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job-application/{jobApplicationId}`;
        urlPath = urlPath.replace(`{${"jobApplicationId"}}`, encodeURIComponent(String(requestParameters['jobApplicationId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetJobApplicationResultFromJSON(jsonValue));
    }
    /**
     * Get a specific job application
     */
    async getJobApplication(jobApplicationId, initOverrides) {
        const response = await this.getJobApplicationRaw({ jobApplicationId: jobApplicationId }, initOverrides);
        return await response.value();
    }
    /**
     * Get notification settings for a job, showing all teammates and their current subscription status
     */
    async getJobNotificationSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters['jobId'] == null) {
            throw new runtime.RequiredError('jobId', 'Required parameter "jobId" was null or undefined when calling getJobNotificationSettings().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job/{jobId}/notification-settings`;
        urlPath = urlPath.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters['jobId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetJobNotificationSettingsResultFromJSON(jsonValue));
    }
    /**
     * Get notification settings for a job, showing all teammates and their current subscription status
     */
    async getJobNotificationSettings(jobId, initOverrides) {
        const response = await this.getJobNotificationSettingsRaw({ jobId: jobId }, initOverrides);
        return await response.value();
    }
    /**
     */
    async getLeadEmployerRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/lead/account`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeadEmployerResultFromJSON(jsonValue));
    }
    /**
     */
    async getLeadEmployer(initOverrides) {
        const response = await this.getLeadEmployerRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getMatchChatWithMessagesForEmployerRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getMatchChatWithMessagesForEmployer().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/match/{id}/chat`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetMatchChatWithMessagesResultFromJSON(jsonValue));
    }
    /**
     */
    async getMatchChatWithMessagesForEmployer(id, initOverrides) {
        const response = await this.getMatchChatWithMessagesForEmployerRaw({ id: id }, initOverrides);
        return await response.value();
    }
    /**
     */
    async getMatchedUserRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getMatchedUser().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/match/{id}/user`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetMatchedUserResultFromJSON(jsonValue));
    }
    /**
     */
    async getMatchedUser(id, initOverrides) {
        const response = await this.getMatchedUserRaw({ id: id }, initOverrides);
        return await response.value();
    }
    /**
     */
    async getMatchingConfigurationRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/company-matching-configuration`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompanyMatchingConfigurationResultFromJSON(jsonValue));
    }
    /**
     */
    async getMatchingConfiguration(initOverrides) {
        const response = await this.getMatchingConfigurationRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getMyCompanyRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/company`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompanyFromPortalResultFromJSON(jsonValue));
    }
    /**
     */
    async getMyCompany(initOverrides) {
        const response = await this.getMyCompanyRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getMyCompanyPlanRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/company/plan`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompanyPlanResultFromJSON(jsonValue));
    }
    /**
     */
    async getMyCompanyPlan(initOverrides) {
        const response = await this.getMyCompanyPlanRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getProfileRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/profile`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetEmployerProfileResultFromJSON(jsonValue));
    }
    /**
     */
    async getProfile(initOverrides) {
        const response = await this.getProfileRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getRecruiteeConnectionRaw(requestParameters, initOverrides) {
        if (requestParameters['connectionId'] == null) {
            throw new runtime.RequiredError('connectionId', 'Required parameter "connectionId" was null or undefined when calling getRecruiteeConnection().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/recruitee-connection/recruitee/{connectionId}`;
        urlPath = urlPath.replace(`{${"connectionId"}}`, encodeURIComponent(String(requestParameters['connectionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetAtsIntegrationConnectionResultRecruiteeConnectionConfigFromJSON(jsonValue));
    }
    /**
     */
    async getRecruiteeConnection(connectionId, initOverrides) {
        const response = await this.getRecruiteeConnectionRaw({ connectionId: connectionId }, initOverrides);
        return await response.value();
    }
    /**
     */
    async getStatisticsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/dashboard/statistics`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompanyStatisticsResultFromJSON(jsonValue));
    }
    /**
     */
    async getStatistics(initOverrides) {
        const response = await this.getStatisticsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getSubscriptionRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/invoice/subscription`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetSubscriptionResultFromJSON(jsonValue));
    }
    /**
     */
    async getSubscription(initOverrides) {
        const response = await this.getSubscriptionRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get all comments for a user (candidate) visible to the current employer\'s company.
     */
    async getUserCommentsRaw(requestParameters, initOverrides) {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling getUserComments().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/v1/employer/user/comments/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserCommentsResultFromJSON(jsonValue));
    }
    /**
     * Get all comments for a user (candidate) visible to the current employer\'s company.
     */
    async getUserComments(userId, initOverrides) {
        const response = await this.getUserCommentsRaw({ userId: userId }, initOverrides);
        return await response.value();
    }
    /**
     * List all matches for the current company
     */
    async listAllMatchesRaw(requestParameters, initOverrides) {
        if (requestParameters['showClosed'] == null) {
            throw new runtime.RequiredError('showClosed', 'Required parameter "showClosed" was null or undefined when calling listAllMatches().');
        }
        const queryParameters = {};
        if (requestParameters['showClosed'] != null) {
            queryParameters['showClosed'] = requestParameters['showClosed'];
        }
        if (requestParameters['limit'] != null) {
            queryParameters['Limit'] = requestParameters['limit'];
        }
        if (requestParameters['offset'] != null) {
            queryParameters['Offset'] = requestParameters['offset'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/match`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListMatchesResultFromJSON(jsonValue));
    }
    /**
     * List all matches for the current company
     */
    async listAllMatches(showClosed, limit, offset, initOverrides) {
        const response = await this.listAllMatchesRaw({ showClosed: showClosed, limit: limit, offset: offset }, initOverrides);
        return await response.value();
    }
    /**
     */
    async listAllSkillsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/skill/v2`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListAllSkillsResultFromJSON(jsonValue));
    }
    /**
     */
    async listAllSkills(initOverrides) {
        const response = await this.listAllSkillsRaw(initOverrides);
        return await response.value();
    }
    /**
     * List all waiting job applications for the current company
     */
    async listAllWaitingJobApplicationsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['limit'] != null) {
            queryParameters['Limit'] = requestParameters['limit'];
        }
        if (requestParameters['offset'] != null) {
            queryParameters['Offset'] = requestParameters['offset'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job-application`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListAllWaitingJobApplicationsResultFromJSON(jsonValue));
    }
    /**
     * List all waiting job applications for the current company
     */
    async listAllWaitingJobApplications(limit, offset, initOverrides) {
        const response = await this.listAllWaitingJobApplicationsRaw({ limit: limit, offset: offset }, initOverrides);
        return await response.value();
    }
    /**
     */
    async listAtsJobsRaw(requestParameters, initOverrides) {
        if (requestParameters['connectionId'] == null) {
            throw new runtime.RequiredError('connectionId', 'Required parameter "connectionId" was null or undefined when calling listAtsJobs().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/integration-connection/ats-jobs/{connectionId}`;
        urlPath = urlPath.replace(`{${"connectionId"}}`, encodeURIComponent(String(requestParameters['connectionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListAtsJobsResultFromJSON(jsonValue));
    }
    /**
     */
    async listAtsJobs(connectionId, initOverrides) {
        const response = await this.listAtsJobsRaw({ connectionId: connectionId }, initOverrides);
        return await response.value();
    }
    /**
     */
    async listCompanySubscriptionsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/invoice/subscriptions`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListCompanySubscriptionsResultFromJSON(jsonValue));
    }
    /**
     */
    async listCompanySubscriptions(initOverrides) {
        const response = await this.listCompanySubscriptionsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async listConferenceChatsEmployerRaw(requestParameters, initOverrides) {
        if (requestParameters['conferenceId'] == null) {
            throw new runtime.RequiredError('conferenceId', 'Required parameter "conferenceId" was null or undefined when calling listConferenceChatsEmployer().');
        }
        const queryParameters = {};
        if (requestParameters['conferenceId'] != null) {
            queryParameters['conferenceId'] = requestParameters['conferenceId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/conference/chat`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListConferenceChatsResultFromJSON(jsonValue));
    }
    /**
     */
    async listConferenceChatsEmployer(conferenceId, initOverrides) {
        const response = await this.listConferenceChatsEmployerRaw({ conferenceId: conferenceId }, initOverrides);
        return await response.value();
    }
    /**
     */
    async listCreditTransactionsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/invoice/credits`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListCreditTransactionsResultFromJSON(jsonValue));
    }
    /**
     */
    async listCreditTransactions(initOverrides) {
        const response = await this.listCreditTransactionsRaw(initOverrides);
        return await response.value();
    }
    /**
     * List all education levels
     */
    async listEducationLevelsWithTrackCategoryRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/static-data/education-levels`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListEducationLevelsWithTrackCategoryResultFromJSON(jsonValue));
    }
    /**
     * List all education levels
     */
    async listEducationLevelsWithTrackCategory(initOverrides) {
        const response = await this.listEducationLevelsWithTrackCategoryRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async listEmployersForCompanyRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/company/employers`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListOtherEmployersForCompanyResultFromJSON(jsonValue));
    }
    /**
     */
    async listEmployersForCompany(initOverrides) {
        const response = await this.listEmployersForCompanyRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async listIntegrationsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/integration`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListIntegrationsResultFromJSON(jsonValue));
    }
    /**
     */
    async listIntegrations(initOverrides) {
        const response = await this.listIntegrationsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async listInvoicesForCompanyRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/invoice`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListInvoicesForCompanyResultFromJSON(jsonValue));
    }
    /**
     */
    async listInvoicesForCompany(initOverrides) {
        const response = await this.listInvoicesForCompanyRaw(initOverrides);
        return await response.value();
    }
    /**
     * List all rejection reasons for job applications of a company.
     */
    async listJobApplicationRejectionReasonsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job-application/rejection-reasons`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListJobApplicationRejectionReasonsResultFromJSON(jsonValue));
    }
    /**
     * List all rejection reasons for job applications of a company.
     */
    async listJobApplicationRejectionReasons(initOverrides) {
        const response = await this.listJobApplicationRejectionReasonsRaw(initOverrides);
        return await response.value();
    }
    /**
     * List all job applications for a given job
     */
    async listJobApplicationsForJobRaw(requestParameters, initOverrides) {
        if (requestParameters['jobId'] == null) {
            throw new runtime.RequiredError('jobId', 'Required parameter "jobId" was null or undefined when calling listJobApplicationsForJob().');
        }
        const queryParameters = {};
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job/{jobId}/job-applications`;
        urlPath = urlPath.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters['jobId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListJobApplicationsForJobResultFromJSON(jsonValue));
    }
    /**
     * List all job applications for a given job
     */
    async listJobApplicationsForJob(jobId, status, initOverrides) {
        const response = await this.listJobApplicationsForJobRaw({ jobId: jobId, status: status }, initOverrides);
        return await response.value();
    }
    /**
     * List all jobs for the current company
     */
    async listJobsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['limit'] != null) {
            queryParameters['Limit'] = requestParameters['limit'];
        }
        if (requestParameters['offset'] != null) {
            queryParameters['Offset'] = requestParameters['offset'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListJobsInPortalResultFromJSON(jsonValue));
    }
    /**
     * List all jobs for the current company
     */
    async listJobs(limit, offset, initOverrides) {
        const response = await this.listJobsRaw({ limit: limit, offset: offset }, initOverrides);
        return await response.value();
    }
    /**
     * List the companies that an employer is allowed to manage
     */
    async listManagedCompaniesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/company-admin`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListManagedCompaniesResultFromJSON(jsonValue));
    }
    /**
     * List the companies that an employer is allowed to manage
     */
    async listManagedCompanies(initOverrides) {
        const response = await this.listManagedCompaniesRaw(initOverrides);
        return await response.value();
    }
    /**
     * List matches for a given job
     */
    async listMatchesForJobRaw(requestParameters, initOverrides) {
        if (requestParameters['jobId'] == null) {
            throw new runtime.RequiredError('jobId', 'Required parameter "jobId" was null or undefined when calling listMatchesForJob().');
        }
        if (requestParameters['showClosed'] == null) {
            throw new runtime.RequiredError('showClosed', 'Required parameter "showClosed" was null or undefined when calling listMatchesForJob().');
        }
        const queryParameters = {};
        if (requestParameters['showClosed'] != null) {
            queryParameters['showClosed'] = requestParameters['showClosed'];
        }
        if (requestParameters['limit'] != null) {
            queryParameters['Limit'] = requestParameters['limit'];
        }
        if (requestParameters['offset'] != null) {
            queryParameters['Offset'] = requestParameters['offset'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job/{jobId}/matches`;
        urlPath = urlPath.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters['jobId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListMatchesForJobResultFromJSON(jsonValue));
    }
    /**
     * List matches for a given job
     */
    async listMatchesForJob(jobId, showClosed, limit, offset, initOverrides) {
        const response = await this.listMatchesForJobRaw({ jobId: jobId, showClosed: showClosed, limit: limit, offset: offset }, initOverrides);
        return await response.value();
    }
    /**
     * List Payment options. Contains subscriptions and credit packages.
     */
    async listPaymentOptionsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/employer-onboarding/payment-options`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListPaymentOptionsResultFromJSON(jsonValue));
    }
    /**
     * List Payment options. Contains subscriptions and credit packages.
     */
    async listPaymentOptions(initOverrides) {
        const response = await this.listPaymentOptionsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async listReferralInvitesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/admin/employer/list-referral-invites`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListReferralInvitesResultFromJSON(jsonValue));
    }
    /**
     */
    async listReferralInvites(initOverrides) {
        const response = await this.listReferralInvitesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async listUnhandledJobsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['limit'] != null) {
            queryParameters['Limit'] = requestParameters['limit'];
        }
        if (requestParameters['offset'] != null) {
            queryParameters['Offset'] = requestParameters['offset'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/dashboard/unhandled-jobs`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListUnhandledJobsResultFromJSON(jsonValue));
    }
    /**
     */
    async listUnhandledJobs(limit, offset, initOverrides) {
        const response = await this.listUnhandledJobsRaw({ limit: limit, offset: offset }, initOverrides);
        return await response.value();
    }
    /**
     * List all unhandled matches for the current company
     */
    async listUnhandledMatchesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['limit'] != null) {
            queryParameters['Limit'] = requestParameters['limit'];
        }
        if (requestParameters['offset'] != null) {
            queryParameters['Offset'] = requestParameters['offset'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/dashboard/unhandled-matches`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListUnhandledMatchesResultFromJSON(jsonValue));
    }
    /**
     * List all unhandled matches for the current company
     */
    async listUnhandledMatches(limit, offset, initOverrides) {
        const response = await this.listUnhandledMatchesRaw({ limit: limit, offset: offset }, initOverrides);
        return await response.value();
    }
    /**
     */
    async listUnreadConferenceChatsEmployerRaw(requestParameters, initOverrides) {
        if (requestParameters['conferenceId'] == null) {
            throw new runtime.RequiredError('conferenceId', 'Required parameter "conferenceId" was null or undefined when calling listUnreadConferenceChatsEmployer().');
        }
        const queryParameters = {};
        if (requestParameters['conferenceId'] != null) {
            queryParameters['conferenceId'] = requestParameters['conferenceId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/conference/chat-unread`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ListUnreadConferenceChatsResultFromJSON(jsonValue));
    }
    /**
     */
    async listUnreadConferenceChatsEmployer(conferenceId, initOverrides) {
        const response = await this.listUnreadConferenceChatsEmployerRaw({ conferenceId: conferenceId }, initOverrides);
        return await response.value();
    }
    /**
     */
    async mapJobWithAtsJobRaw(requestParameters, initOverrides) {
        if (requestParameters['connectionId'] == null) {
            throw new runtime.RequiredError('connectionId', 'Required parameter "connectionId" was null or undefined when calling mapJobWithAtsJob().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/integration-connection/ats-jobs/{connectionId}`;
        urlPath = urlPath.replace(`{${"connectionId"}}`, encodeURIComponent(String(requestParameters['connectionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MapJobWithAtsJobCommandDtoToJSON(requestParameters['mapJobWithAtsJobCommandDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async mapJobWithAtsJob(connectionId, mapJobWithAtsJobCommandDto, initOverrides) {
        const response = await this.mapJobWithAtsJobRaw({ connectionId: connectionId, mapJobWithAtsJobCommandDto: mapJobWithAtsJobCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     */
    async markMatchAsReadOrUnreadRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/match/mark`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkMatchCommandDtoToJSON(requestParameters['markMatchCommandDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async markMatchAsReadOrUnread(markMatchCommandDto, initOverrides) {
        await this.markMatchAsReadOrUnreadRaw({ markMatchCommandDto: markMatchCommandDto }, initOverrides);
    }
    /**
     * An employer reacts to the best found candidate. The employee will get notified that the Employer is interested in the Employee\'s profile.
     */
    async reactToBestCandidateRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job/react-best-candidate`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReactToCandidateCommandDtoToJSON(requestParameters['reactToCandidateCommandDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * An employer reacts to the best found candidate. The employee will get notified that the Employer is interested in the Employee\'s profile.
     */
    async reactToBestCandidate(reactToCandidateCommandDto, initOverrides) {
        const response = await this.reactToBestCandidateRaw({ reactToCandidateCommandDto: reactToCandidateCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     * An employer rejects a job application
     */
    async rejectJobApplicationRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job-application/reject`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RejectJobApplicationCommandDtoToJSON(requestParameters['rejectJobApplicationCommandDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => RejectJobApplicationResultFromJSON(jsonValue));
    }
    /**
     * An employer rejects a job application
     */
    async rejectJobApplication(rejectJobApplicationCommandDto, initOverrides) {
        const response = await this.rejectJobApplicationRaw({ rejectJobApplicationCommandDto: rejectJobApplicationCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     * Request a login link to be sent to the user\'s email via jwt token Currently only for employers with auth provider Internal Jwt aka Lead employers
     */
    async requestLoginLinkRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/authentication/login-link`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'],
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Request a login link to be sent to the user\'s email via jwt token Currently only for employers with auth provider Internal Jwt aka Lead employers
     */
    async requestLoginLink(body, initOverrides) {
        await this.requestLoginLinkRaw({ body: body }, initOverrides);
    }
    /**
     * Reset the company of an employer.
     */
    async resetManagedCompanyRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/company-admin/reset`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Reset the company of an employer.
     */
    async resetManagedCompany(initOverrides) {
        await this.resetManagedCompanyRaw(initOverrides);
    }
    /**
     */
    async resetMatchingConfigurationRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/company-matching-configuration`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async resetMatchingConfiguration(initOverrides) {
        await this.resetMatchingConfigurationRaw(initOverrides);
    }
    /**
     * Send a Complete Profile Request to the anonymous user.
     */
    async sendCompleteProfileRequestRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job-application/complete-profile-request`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendCompleteProfileRequestCommandDtoToJSON(requestParameters['sendCompleteProfileRequestCommandDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Send a Complete Profile Request to the anonymous user.
     */
    async sendCompleteProfileRequest(sendCompleteProfileRequestCommandDto, initOverrides) {
        await this.sendCompleteProfileRequestRaw({ sendCompleteProfileRequestCommandDto: sendCompleteProfileRequestCommandDto }, initOverrides);
    }
    /**
     */
    async sendConferenceChatMessageEmployerRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/conference/chat`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendMessageCommandDtoToJSON(requestParameters['sendMessageCommandDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ChatMessageDtoFromJSON(jsonValue));
    }
    /**
     */
    async sendConferenceChatMessageEmployer(sendMessageCommandDto, initOverrides) {
        const response = await this.sendConferenceChatMessageEmployerRaw({ sendMessageCommandDto: sendMessageCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     */
    async sendMatchChatMessageForEmployerRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/match/chat`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendMessageCommandDtoToJSON(requestParameters['sendMessageCommandDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ChatMessageDtoFromJSON(jsonValue));
    }
    /**
     */
    async sendMatchChatMessageForEmployer(sendMessageCommandDto, initOverrides) {
        const response = await this.sendMatchChatMessageForEmployerRaw({ sendMessageCommandDto: sendMessageCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     */
    async sendPollRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/match/poll`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendPollCommandDtoToJSON(requestParameters['sendPollCommandDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SendPollResultFromJSON(jsonValue));
    }
    /**
     */
    async sendPoll(sendPollCommandDto, initOverrides) {
        const response = await this.sendPollRaw({ sendPollCommandDto: sendPollCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     */
    async sendRequestToAccountManagerRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/company/send-account-manager-request`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendRequestToAccountManagerCommandDtoToJSON(requestParameters['sendRequestToAccountManagerCommandDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async sendRequestToAccountManager(sendRequestToAccountManagerCommandDto, initOverrides) {
        const response = await this.sendRequestToAccountManagerRaw({ sendRequestToAccountManagerCommandDto: sendRequestToAccountManagerCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     */
    async setMatchingConfigurationRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/company-matching-configuration`;
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetCompanyMatchingConfigurationCommandDtoToJSON(requestParameters['setCompanyMatchingConfigurationCommandDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async setMatchingConfiguration(setCompanyMatchingConfigurationCommandDto, initOverrides) {
        await this.setMatchingConfigurationRaw({ setCompanyMatchingConfigurationCommandDto: setCompanyMatchingConfigurationCommandDto }, initOverrides);
    }
    /**
     * An employer starts a match for a job application
     */
    async startMatchRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job-application/start-match`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartMatchCommandDtoToJSON(requestParameters['startMatchCommandDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => StartMatchResultFromJSON(jsonValue));
    }
    /**
     * An employer starts a match for a job application
     */
    async startMatch(startMatchCommandDto, initOverrides) {
        const response = await this.startMatchRaw({ startMatchCommandDto: startMatchCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateHomerunConnectionRaw(requestParameters, initOverrides) {
        if (requestParameters['connectionId'] == null) {
            throw new runtime.RequiredError('connectionId', 'Required parameter "connectionId" was null or undefined when calling updateHomerunConnection().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/homerun-connection/{connectionId}`;
        urlPath = urlPath.replace(`{${"connectionId"}}`, encodeURIComponent(String(requestParameters['connectionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfigToJSON(requestParameters['updateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updateHomerunConnection(connectionId, updateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig, initOverrides) {
        const response = await this.updateHomerunConnectionRaw({ connectionId: connectionId, updateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig: updateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig }, initOverrides);
        return await response.value();
    }
    /**
     * Update a job
     */
    async updateJobRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job`;
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateJobCommandDtoToJSON(requestParameters['updateJobCommandDto']),
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Update a job
     */
    async updateJob(updateJobCommandDto, initOverrides) {
        const response = await this.updateJobRaw({ updateJobCommandDto: updateJobCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     * Update notification settings for a job, setting which teammates should receive notifications
     */
    async updateJobNotificationSettingsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job/notification-settings`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateJobNotificationSettingsCommandDtoToJSON(requestParameters['updateJobNotificationSettingsCommandDto']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update notification settings for a job, setting which teammates should receive notifications
     */
    async updateJobNotificationSettings(updateJobNotificationSettingsCommandDto, initOverrides) {
        await this.updateJobNotificationSettingsRaw({ updateJobNotificationSettingsCommandDto: updateJobNotificationSettingsCommandDto }, initOverrides);
    }
    /**
     * Update the published status of a job
     */
    async updateJobPublishedRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/job/update-published`;
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateJobPublishedCommandDtoToJSON(requestParameters['updateJobPublishedCommandDto']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Update the published status of a job
     */
    async updateJobPublished(updateJobPublishedCommandDto, initOverrides) {
        const response = await this.updateJobPublishedRaw({ updateJobPublishedCommandDto: updateJobPublishedCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     * Update the company that an employer manages.
     */
    async updateManagedCompanyRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/company-admin/update`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'],
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update the company that an employer manages.
     */
    async updateManagedCompany(body, initOverrides) {
        await this.updateManagedCompanyRaw({ body: body }, initOverrides);
    }
    /**
     */
    async updateMyCompanyRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/company`;
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCompanyFromPortalCommandDtoToJSON(requestParameters['updateCompanyFromPortalCommandDto']),
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     */
    async updateMyCompany(updateCompanyFromPortalCommandDto, initOverrides) {
        const response = await this.updateMyCompanyRaw({ updateCompanyFromPortalCommandDto: updateCompanyFromPortalCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateProfileRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/profile`;
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEmployerProfileCommandDtoToJSON(requestParameters['updateEmployerProfileCommandDto']),
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     */
    async updateProfile(updateEmployerProfileCommandDto, initOverrides) {
        const response = await this.updateProfileRaw({ updateEmployerProfileCommandDto: updateEmployerProfileCommandDto }, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateRecruiteeConnectionRaw(requestParameters, initOverrides) {
        if (requestParameters['connectionId'] == null) {
            throw new runtime.RequiredError('connectionId', 'Required parameter "connectionId" was null or undefined when calling updateRecruiteeConnection().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        let urlPath = `/employer/recruitee-connection/recruitee/{connectionId}`;
        urlPath = urlPath.replace(`{${"connectionId"}}`, encodeURIComponent(String(requestParameters['connectionId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfigToJSON(requestParameters['updateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updateRecruiteeConnection(connectionId, updateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig, initOverrides) {
        const response = await this.updateRecruiteeConnectionRaw({ connectionId: connectionId, updateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig: updateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig }, initOverrides);
        return await response.value();
    }
    /**
     * Upload Provisional Company Image
     */
    async uploadProvisionalImageRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization Bearer"] = await this.configuration.apiKey("Authorization Bearer"); // Bearer authentication
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file']);
        }
        let urlPath = `/employer/company/provisional-image`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ImageDtoFromJSON(jsonValue));
    }
    /**
     * Upload Provisional Company Image
     */
    async uploadProvisionalImage(file, initOverrides) {
        const response = await this.uploadProvisionalImageRaw({ file: file }, initOverrides);
        return await response.value();
    }
}
